import { DefaultTheme } from 'styled-components';
import { convertHex } from './convertHex';

const theme: DefaultTheme = {
  colors: {
    dolphin: '#68686A',
    dolphin032: convertHex('#68686A', 0.32),
    malibu: '#5CABDD',
    malibu06: convertHex('#5CABDD', 0.6),
    malibu08: convertHex('#5CABDD', 0.8),
    malibu04: convertHex('#5CABDD', 0.4),
    malibu01: convertHex('#5CABDD', 0.1),
    mainlyblue: '#f3f6f9',
    nero: '#212121',
    eastBay: '#464E5F',
    comet: '#68686A',
    ghost: '#B5B5C3',
    ghost06: convertHex('#B5B5C3', 0.6),
    ghost07: convertHex('#B5B5C3', 0.7),
    aliceBlue: '#e1f0ff',
    aliceBlue04: convertHex('#e1f0ff', 0.4),
    aliceBlue06: convertHex('#e1f0ff', 0.6),
    lightSeaGreen: '#1BC5BD',
    lightSeaGreen06: convertHex('#1BC5BD', 0.6),
    oysterBay: '#C9F7F5',
    radicalRed: '#F64E60',
    radicalRed01: convertHex('#F64E60', 0.1),
    radicalRed03: convertHex('#F64E60', 0.3),
    palePink: '#FFE2E5',
    orange: '#FFA800',
    orange01: convertHex('#FFA800', 0.1),
    earlyDawn: '#FFF4DE',
    kashmirBlue: '#576688',
    white: '#ffffff',
    grey: '#7B7B7B',
    solitude: '#EBEDF3',
    solitude06: convertHex('#EBEDF3', 0.6),
    lightSlateGrey: '#818896',
    lightSlateGrey01: convertHex('#818896', 0.1),
    lightSlateGrey06: convertHex('#818896', 0.6),
    opaqueLightGrey: '#F5F5F5',
    black: '#000000',
    black0004: convertHex('#000000', 0.004),
    black012: convertHex('#000000', 0.12),
    black05: convertHex('#000000', 0.5),
    linkWater: '#B8C5D3',
    linkWater06: convertHex('#B8C5D3', 0.6),
    hanPurple: '#783BF5',
    hanPurple01: convertHex('#783BF5', 0.1),
    deepCerise: '#DE4087',
    deepCerise01: convertHex('#DE4087', 0.1),
    sun: '#F5833B',
    sun01: convertHex('#F5833B', 0.1),
    sun03: convertHex('#F5833B', 0.3),
    butterflyBush: '#5E5A8D',
    butterflyBush01: convertHex('#5E5A8D', 0.1),
    paleBlue: '#E9F6FF',
    lightsolitude: '#F3F6F9',
    topaz: '#80808F',
    yellow: '#FFD600',
    yellow01: convertHex('#FFD600', 0.1),
    green: '#8ABE69',
    green01: convertHex('#8ABE69', 0.1),
    darkGrayishBlue: '#3f4254',
    shadowBorderGrey: 'rgba(27, 31, 35, 0.15)',
  },
  printColors: {
    black: '#000000',
    opaqueLightGrey: '#F5F5F5',
    lightsolitude: '#F3F6F9',
  },
  typography: {
    fontFamily: ['"Poppins"', 'sans-serif'].join(','),
  },
};

export default theme;
